export enum CompanySearchFieldMode {
  Autocomplete = 'autocomplete',
  FreeText = 'freeText',
}
